import toggleMenu from "./scripts/MobileMenu";
import carousel from "./scripts/carousel";
import slider from "./scripts/Slider";
import setPinnedJobs from "./scripts/SetPinnedJobs";
import updatePinnedJobs from "./scripts/UpdatePinnedJobs";
import setPinnedJobsSection from "./scripts/SetPinnedJobsSection";
import imageTextParallax from "./scripts/ImageTextParallax";
import formUpdate from "./scripts/FormUpdate";
import bookHeadingParallax from "./scripts/BookHeadingParallax";
import Aos from "aos";
import parallaxSection from "./scripts/ParallaxSection";
import jobFilters from "./scripts/JobFilters";
import typographyAnimation from "./scripts/TypographyAnimation";
import removeFooter from "./scripts/RemoveFooter";
import contactBlockForm from "./scripts/ContactBlockForm";
import copyClipboard from "./scripts/copyClipboard";

addEventListener('DOMContentLoaded', (event) => {
   setPinnedJobs();

   const pinnedJobsSection = [...document.querySelectorAll('[data-js-pinned-jobs-section]')];
   if (pinnedJobsSection.length > 0) {
      setPinnedJobsSection();
   }

   setTimeout(() => {
      Aos.init({
         duration: 800,
         once: true,
      });
   }, 120);

   const actions = {
      toggleMenu,
      updatePinnedJobs,
      formUpdate,
      copyClipboard,
   };

   addEventListener('click', (event) => {
      if ('action' in event.target.dataset) {
         if (event.target.dataset.action in actions) {
            actions[event.target.dataset.action](event);
         }
      }
   });

   const carousels = [...document.querySelectorAll('[data-carousel]')].map((el) => carousel({ el }));
   const sliders = [...document.querySelectorAll('[data-slider]')].map((el) => slider({ el }));
   const imageTextParallaxSection = [...document.querySelectorAll('[data-image-text-parallax]')].map((el) => imageTextParallax({ el }));
   const bookHeadingParallaxSection = [...document.querySelectorAll('[data-book-heading-parallax]')].map((el) => bookHeadingParallax({ el }));
   const parallaxSections = [...document.querySelectorAll('[data-parallax]')].map((el) => parallaxSection({ el }));
   const jobFilterSections = [...document.querySelectorAll('[data-job-filters]')].map((el) => jobFilters({ el }));
   const typographyAnimationSections = [...document.querySelectorAll('[data-typography-animation]')].map((el) => typographyAnimation({ el }));
   const removeFooterItems = [...document.querySelectorAll('[data-remove-footer]')].map((el) => removeFooter({ el }));
   const contactBlockFormsSections = [...document.querySelectorAll('[data-contact-block-form]')].map((el) => contactBlockForm({ el }));

   let windowResizeTimeout;
   window.onresize = function(){
      clearTimeout(windowResizeTimeout);
      const runCodeOnResize = () => {
         const parallaxSections = [...document.querySelectorAll('[data-parallax]')].map((el) => parallaxSection({ el }));
      }
      windowResizeTimeout = setTimeout(runCodeOnResize, 100);
   };
});

